import Vue from "vue";
import Router from "vue-router";
import { getFirstMenu } from "@root/lib/addRoutes.ts";
import options from "@/options.ts";
import { resetPathForRoute } from "./utils";
import { Message } from "element-ui";
import { setGlobalState } from "@root/lib/qiankun/actions.ts";
(window as any).setGlobalState = setGlobalState;
import { K1_YGJ_apolloClient } from "@root/lib/allApolloClient";
import { getMemberStatus } from "@root/graphql/Root.gql";
import store from "@root/store";
/**
 * Meta Description
 * - authenticationNonRequired: Authentication is not required to view
 * - withoutLayout: 该路由不需要 Layout （不管是不是作为qiankun的微应用都不需要 Layout）
 */
Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
/**
 * 分类
 * layoutlessRoutes: 不需要 Layout 的路由
 * layoutnessRoutes: 需要 Layout 的路由
 */
let layoutlessRoutes = [];
let layoutnessRoutes = [];

resetPathForRoute(options.routes).forEach((route: any) => {
  route.meta = route.meta || {};

  const target =
    route.meta.withoutLayout || window.__POWERED_BY_QIANKUN__
      ? layoutlessRoutes
      : layoutnessRoutes;

  target.push(route);
});

/**
 * Instance
 */
const router = new Router({
  mode: "history",
  // 在qiankun环境下 需要重置public path
  base: window.__POWERED_BY_QIANKUN__
    ? process.env.VUE_APP_QIANKUN_PUBLIC_PATH || `/app/${process.env.APP_NAME}`
    : "/",
  routes: [
    // 不需要layout的自定义路由
    ...layoutlessRoutes,

    // 需要layout的自定义路由
    {
      path: "/app/*",
      component: () => import("@root/layout/DefaultLayout.vue"),
      children: [
        // 子路由
        ...layoutnessRoutes,

        // 公共路由配置
        {
          path: "/change",
          component: () => import("@root/views/auth/changePassword.vue"),
          children: [
            {
              path: "/changePassword",
              name: "changePassword",
              component: () => import("@root/views/auth/changePasswordForm.vue")
            }
          ]
        },
        {
          path: "/changePwd",
          name: "changePasswordForm",
          component: () => import("@root/views/auth/changePasswordForm.vue")
        },
        {
          path: "/changePwd/success",
          name: "changePasswordSuccess",
          component: () => import("@root/views/auth/changePasswordSuccess.vue"),
          meta: {
            authenticationNonRequired: true
          }
        },
        {
          path: "/noncooperative",
          name: "noncooperative",
          component: () => import("@root/views/noncooperative/index.vue"),
          meta: {}
        }
      ]
    },

    // 公共路由配置
    {
      path: "/",
      component: () => import("@root/views/login/loginNew.vue"),
      // component: () => import("@root/layout/LoginLayout.vue"),
      children: [
        {
          path: "/login",
          name: "Login",
          component: () => import("@root/views/login/loginAccount.vue"),
          // component: () => import("@root/views/auth/loginUser.vue"),
          meta: {
            authenticationNonRequired: true
          }
        },
        {
          path: "/login/type",
          name: "loginType",
          component: () => import("@root/views/login/loginType.vue"),
          meta: {
            authenticationNonRequired: true
          }
        },
        {
          path: "/login/tenant",
          name: "Tenant",
          component: () => import("@root/views/auth/loginTenant.vue"),
          meta: {
            authenticationNonRequired: true
          }
        },
        {
          path: "/dev/login",
          name: "DevLogin",
          component: () => import("@root/views/auth/loginDev.vue"),
          meta: {
            authenticationNonRequired: true
          }
        }
      ]
    },
    {
      path: "/new",
      name: "NewLogin",
      component: () => import("@root/views/login/loginNew.vue"),

      children: [
        {
          path: "/new/login",
          name: "loginAccount",
          component: () => import("@root/views/login/loginAccount.vue"),
          meta: {
            authenticationNonRequired: true
          }
        }
        // {
        //   path: "/new/login/type",
        //   name: "loginType",
        //   component: () => import("@root/views/login/loginType.vue"),
        //   meta: {
        //     authenticationNonRequired: true
        //   }
        // }
      ]
    },
    {
      path: "/forgetPassword",
      name: "ForgetPassword",
      component: () => import("@root/views/login/forgetPassword.vue"),
      meta: {
        authenticationNonRequired: true
      }
    },
    {
      path: "/resetPasswordSuccess",
      name: "ResetPasswordSuccess",
      component: () => import("@root/views/login/resetPasswordSuccess.vue"),
      meta: {
        authenticationNonRequired: true
      }
    },
    // 个人信息页面修改密码成功页面
    {
      path: "/updatePasswordSuccess",
      name: "UpdatePasswordSuccess",
      meta: {
        authenticationNonRequired: true,
        withoutLayout: true
      },
      component: () => import("@root/views/login/updatePasswordSuccess.vue")
    }
  ]
});

/**
 * Hooks
 */
function isChildRoute(path) {
  if (path.indexOf("/app/") === 0) {
    return true;
  }
  return false;
}
const rawAppendChild = HTMLHeadElement.prototype.appendChild;
const rawAddEventListener = window.addEventListener;

const needCheckOastatusPageName: any = [
  "purchase",
  "cart",
  "logistics",
  "logisticsDetail",
  "Knowledge",
  "KnowledgeDetail",
  "wtActivityType",
  "userManager",
  "roleManager",
  "clientLevel",
  "setPrice",
  "Import"
];

const needCheckOastatusPageUrl: any = [
  "/app/k-one-frontend/selfQuery/STATEMENT_OF_ACCOUNT",
  "/app/k-one-frontend/selfQuery/DEBT_QUERY"
];

router.beforeEach(async (to, from, next) => {
  if (isChildRoute(from.path) && !isChildRoute(to.path)) {
    // 解决子项目跳主项目时，主项目样式丢失问题
    HTMLHeadElement.prototype.appendChild = rawAppendChild;
    window.addEventListener = rawAddEventListener;
  }
  let $dom: any = document.querySelector("#scrollMain");
  $dom && ($dom.scrollTop = 0);
  const token = localStorage.getItem("AuthToken");
  const memberType = localStorage.getItem("memberType");
  const memberCode = localStorage.getItem("memberCode");
  const marketType = localStorage.getItem("marketType");
  // getFirstRoute

  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置

  if (token && memberType) {
    // 跳转特定页面需要请求接口验证账号状态，有权限才可以跳转
    if (
      needCheckOastatusPageName.includes(to.name) ||
      needCheckOastatusPageUrl.includes(to.path)
    ) {
      let { data: res } = await K1_YGJ_apolloClient.query({
        query: getMemberStatus,
        variables: { request: { memberCode, memberType, marketType } }
      });
      let memberInfo: any = res ? res.api : {};
      let status: any = memberInfo.oaStatus || memberInfo.status;
      if (status !== "11") {
        // 非合作状态跳转到非合作提示页面
        let appCode = window.__GTECH_VARIABLES_APP_CODE__;
        let mainRouter: any = (store.state as any).root.mainRouter;
        if (["K-ONE", "WIN-TOGETHER-TBR"].includes(appCode) && mainRouter) {
          mainRouter.replace({ name: "noncooperative" });
        } else {
          next({ name: "noncooperative" });
        }
        return false;
      }
    }

    let data = getFirstMenu();

    if (["", "/"].includes(to.path) && data && data.pageUrl) {
      next({ path: data.pageUrl });
      return false;
    }

    if (window.__POWERED_BY_QIANKUN__) {
      setGlobalState({
        activeRoute: to
      });
    }
    if (
      [
        "loginAccount",
        "Login",
        "Tenant",
        "ForgetPassword",
        "ResetPasswordSuccess"
      ].includes(to.name) &&
      data &&
      data.pageUrl
    ) {
      let typeFromLogin = sessionStorage.getItem("accessLogin");
      if (typeFromLogin === "1") {
        next();
        return false;
      }
      next({ path: data.pageUrl });
      return false;
    }
    next();
  }

  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  // TODO 这里改成在子路由中配置
  else {
    // Note 注释 by jiabo.zhang
    // 我将下面的判断抽象到 meta 头中的 authenticationNonRequired 字段
    // 给一下判断对应的路由加上次 meta 头，代表着该路由对应的页面 不需要token 也可以访问
    // if (to.name === "StoreAnswer") {
    //   next();
    //   return;
    // }
    // if (to.name === "changePasswordSuccess") {
    //   next();
    //   return;
    // }
    // if (to.name === "Login") {
    //   next();
    // } else {
    //   next({ name: "Login" });
    // }

    if (to.meta.authenticationNonRequired) {
      if (window.__POWERED_BY_QIANKUN__) {
        setGlobalState({
          activeRoute: to
        });
      }
      next();
    } else {
      next({ name: "Login" });
    }
  }
});

// by jiabo.zhang
// 以下是原有逻辑
router.onError(err => {
  const pattern = /(Unexpected token|Loading chunk).*?/g;
  const hasChunkLoadingFailed = pattern.test(err.message);

  if (hasChunkLoadingFailed) {
    const vm = new Vue(); // 不从Window引入，怕出问题
    const h = vm.$createElement;
    Message({
      type: "warning",
      duration: 4000,
      showClose: true,
      customClass: "gt-common-dialog-message-container",
      message: h("div", { class: "gt-common-dialog-message-wrap" }, [
        h("p", null, "当前版本有更新，请刷新页面"),
        h(
          "p",
          {
            class: "gt-common-dialog-link-view",
            on: {
              click: () => {
                window.location.replace(window.location.href);
              }
            }
          },
          "或点此刷新"
        )
      ])
    });
  }
});

export default router;
